var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showBeePlugin
    ? _c(
        "div",
        {
          staticClass: "bee-full-screen side-right",
          attrs: { id: _vm.containerId + "-wrapper" },
        },
        [
          _c("incident-message", {
            attrs: { "service-name": "bee", "no-spacing": "" },
            on: { update: _vm.handleIncidentUpdate },
          }),
          _vm._v(" "),
          !_vm.pluginLoaded
            ? _c("page-loader", { attrs: { path: "" } })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "w-100 h-100 position-relative",
              attrs: { id: _vm.containerId },
            },
            [
              !_vm.previewTemplate
                ? _c(
                    "div",
                    {
                      staticClass: "template-help-button bee-header",
                      attrs: { id: "send-email-button" },
                    },
                    [
                      _c("span", { on: { click: _vm.handleManualSendTest } }, [
                        _c("i", {
                          staticClass: "fa fa-envelope-o mr-2",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bee-text px-0" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t("templates.beePlugin.sendTestEmail")
                              ) +
                              "\n        "
                          ),
                        ]),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.previewTemplate
                ? _c(
                    "div",
                    {
                      staticClass: "template-help-button bee-header",
                      attrs: { id: "toggle-help" },
                      on: { click: _vm.handleOpenEditorHelp },
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-question mr-2",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bee-text px-0" }, [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("templates.beePlugin.editorHelp")) +
                            "\n      "
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", {
                staticStyle: { display: "none" },
                attrs: { id: "hide-nav" },
              }),
              _vm._v(" "),
              _vm.previewTemplate
                ? _c(
                    "div",
                    {
                      staticClass:
                        "bee-preview d-lg-flex d-md-none d-flex flex-row align-items-center justify-content-center exit-bee",
                      attrs: { id: "hide-preview-exit" },
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "close-icon btn btn-link p-0",
                          on: { click: _vm.unMountPlugin },
                        },
                        [
                          _c("span", { staticStyle: { display: "none" } }, [
                            _vm._v("Close"),
                          ]),
                          _vm._v(" "),
                          _c("i", { staticClass: "fa fa-times" }),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.previewTemplate
                ? _c(
                    "div",
                    {
                      staticClass: "bee-header exit-bee",
                      attrs: { id: "exit-bee" },
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn bee-text",
                          on: { click: _vm.unMountPlugin },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t("templates.beePlugin.goBack")) +
                              "\n      "
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "bee-header",
                  attrs: { id: "bee-template-name" },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "bee-text",
                      class: {
                        "text-black": _vm.previewTemplate,
                        "background-transparent": _vm.previewTemplate,
                      },
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.templateName) + "\n      "
                      ),
                    ]
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c("send-test-email-modal", {
            ref: "sendTestEmailModal",
            attrs: {
              "test-html": _vm.currentBase64Email,
              "template-id": _vm.templateId,
            },
            on: {
              hidden: function ($event) {
                _vm.currentBase64Email = ""
              },
            },
          }),
          _vm._v(" "),
          _c("create-email-template-modal", {
            ref: "saveAsNewModal",
            attrs: {
              "template-name": _vm.templateName,
              loading: _vm.createLoading.loading,
              "create-succeeded": _vm.createLoading.success,
            },
            on: { create: _vm.handleCreateAs },
          }),
          _vm._v(" "),
          _c("template-editor-help-modal", { ref: "editorHelpModal" }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }